import { FilterButton } from "../FilterButton/FilterButton";
import { FilterButtonDeselect } from "../FilterButtonDeselect/FilterButtonDeselect";
import {
  CosmosButtonProps,
  CosmosIconChevronRight,
  CosmosTitle,
} from "@cosmos/web-react";
import classnames from "classnames/bind";
import React, { useId, useState } from "react";
import styles from "./FilterPanel.module.css";

const cx = classnames.bind(styles);

export const FilterPanel = ({
  label,
  items,
  deselectAllHref,
  selected: selectedProp,
  disabled,
  clearAllLabel,
  buttonShape,
  onDeselectAllClick,
}: {
  label: string;
  items: {
    onClick: CosmosButtonProps["onClick"];
    title: string;
    selected: boolean;
    href: string;
  }[];
  deselectAllHref: string;
  selected?: boolean;
  disabled?: boolean;
  clearAllLabel: string;
  buttonShape?: "pill" | "rectangle";
  onDeselectAllClick?: CosmosButtonProps["onClick"];
}) => {
  const [internalSelected, setInternalSelected] = useState(true);
  const selected = selectedProp !== undefined ? selectedProp : internalSelected;
  const panelId = useId();

  const handleToggle = () => {
    const newSelected = !selected;
    if (selectedProp === undefined) {
      setInternalSelected(newSelected);
    }
  };

  return (
    <div className={cx("container")} data-disabled={disabled}>
      <div className={cx("inner")}>
        <button
          className={cx("button")}
          aria-expanded={selected}
          aria-controls={panelId}
          onClick={handleToggle}
          disabled={disabled}
        >
          <CosmosTitle
            tag="span"
            kind="subtle"
            className={cx("button-label")}
            size="x-small"
            appearance="dark"
          >
            {label}
          </CosmosTitle>
          <CosmosIconChevronRight className={cx("button-icon")} />
        </button>
        <div className={cx("panel-expander")}>
          <div className={cx("panel-expander-inner")}>
            <div className={cx("panel")} id={panelId} aria-hidden={!selected}>
              {items && (
                <div className={cx("tags")}>
                  {items.map((item, index) => (
                    <FilterButton
                      key={index}
                      shape={buttonShape}
                      selected={item.selected}
                      disabled={disabled}
                      onClick={item.onClick}
                      href={item.href}
                    >
                      {item.title}
                    </FilterButton>
                  ))}
                  <FilterButtonDeselect
                    disabled={disabled || !items.some((item) => item.selected)}
                    href={deselectAllHref}
                    onClick={onDeselectAllClick}
                  >
                    {clearAllLabel}
                  </FilterButtonDeselect>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
